var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100px","height":"100px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getsheet}},[_vm._v("获取工作表数据")])],1),_c('div',{staticStyle:{"margin":"0px","padding":"0px","position":"absolute","width":"100%","left":"0px","top":"50px","bottom":"0px","outline":"none"},attrs:{"id":"luckysheet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }